import { React, useRef, useEffect, useCallback } from 'react';
import styled from 'styled-components';

export default function NewTextArea(props) {
	const { value, setValue, placeholder, checkURL } = props;

  const TextRef = useRef();

  // 입력값 변경 시 textarea 높이 자동 조정 //
  useEffect(() => {
    if (!TextRef.current) return;
    TextRef.current.style.height = 'auto';
    TextRef.current.style.height = TextRef.current.scrollHeight + 'px';
  }, [value])

  const handleResizeHeight = useCallback(() => {
    TextRef.current.style.height = 'auto';
    TextRef.current.style.height = TextRef.current.scrollHeight + 'px';
  }, []);


	function handleChange(e) {
		setValue(e.target.value);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

	function handlePaste(e) {
		checkURL();
	}

	function handleKeyPress(e) {
		if (e.key === 'Enter' || e.key === ' ') {
			checkURL();
		}
	}
	
	return (
		<Input
			ref={TextRef}
			type="text"
			placeholder={placeholder}
			value={value}
			onPaste={handlePaste}
			onChange={handleChange}
			onFocus={handleFocus}
			onBlur={handleBlur}
      		onInput={handleResizeHeight} 
			onKeyPress={handleKeyPress} />
	)
};

const Input = styled.textarea`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

	padding: 15px;

	box-sizing: border-box;
	width: 550px;
	min-height: 272px;

  resize: none;
  overflow: hidden;

  font-family: NotoSansKR-Medium;
  font-size: 14px;
  line-height: 22px;

  color: ${props => props.theme.text};

  border: 1px solid ${props => props.theme.line};
  background-color: ${props => props.theme.subBackground};
	border-radius: 8px;

	outline: none;

	::placeholder {
		color: ${props => props.theme.line};
	}
`;